// Utility functions for swiper management

function isMobile() {
  return window.innerWidth < 768;
}

function getCurrentMode() {
  return document.body.getAttribute('data-card-mode') || 'produit';
}

function loadRemainingImages(swiperWrapper) {
  const remainingImages = swiperWrapper.getAttribute('data-remaining-images');
  if (!remainingImages || remainingImages.trim() === '') {
    initializeSwiperForCard(swiperWrapper);
    return;
  }

  const imageDataStrings = remainingImages.split('|').map(str => str.trim()).filter(str => str !== '');
  
  if (imageDataStrings.length === 0) {
    initializeSwiperForCard(swiperWrapper);
    return;
  }

  const card = swiperWrapper.closest('.card-wrapper');
  const productLink = swiperWrapper.querySelector('.swiper-slide a');
  const productUrl = productLink ? productLink.getAttribute('href') : '#';

  imageDataStrings.forEach((imageDataString, index) => {
    // Format: url; alt; width; height; sizes; srcset
    const attributes = imageDataString.split(';').map(attr => attr.trim());
    
    if (attributes.length < 6) {
      return;
    }
    
    const [url, alt, width, height, sizes, srcset] = attributes;
    
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
        
    const img = document.createElement('img');
    img.setAttribute('src', url);
    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', sizes);
    img.setAttribute('alt', alt || '');
    img.setAttribute('width', width || '1000');
    img.setAttribute('height', height || '1000');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('class', 'motion-reduce');
    
    slide.appendChild(img);
    swiperWrapper.appendChild(slide);
  });

  swiperWrapper.removeAttribute('data-remaining-images');
  initializeSwiperForCard(swiperWrapper);
}

function setupSwiperEventListeners(card, swiper) {
  let isHovering = false;
  let isManualNavigation = false;

  const navNext = card.querySelector('.swiper-button-next');
  const navPrev = card.querySelector('.swiper-button-prev');
  
  if (navNext) {
    navNext.addEventListener('mousedown', () => {
      isManualNavigation = true;
      swiper.params.effect = 'creative';
      swiper.update();
    });
  }
  
  if (navPrev) {
    navPrev.addEventListener('mousedown', () => {
      isManualNavigation = true;
      swiper.params.effect = 'creative';
      swiper.update();
    });
  }

  swiper.on('slideChangeTransitionEnd', () => {
    isManualNavigation = false;
  });

  card.addEventListener('mouseenter', () => {
    if (!isManualNavigation) {
      isHovering = true;
      const mode = getCurrentMode();
      
      swiper.params.effect = 'fade';
      swiper.params.fadeEffect = {
        crossFade: true
      };
      swiper.params.speed = 400;
      swiper.update();

      if (mode === 'modele') {
        swiper.slideToLoop(0, 400);
      } else if (mode === 'produit') {
        swiper.slideToLoop(1, 400);
      }
    }
  });

  card.addEventListener('mouseleave', () => {
    isHovering = false;
    const mode = getCurrentMode();
    
    swiper.params.effect = 'fade';
    swiper.params.fadeEffect = {
      crossFade: true
    };
    swiper.params.speed = 400;
    swiper.update();
    
    if (mode === 'modele') {
      swiper.slideToLoop(1, 400);
    } else if (mode === 'produit') {
      swiper.slideToLoop(0, 400);
    }
  });
}

function initializeSwiperForCard(swiperWrapper) {
  const card = swiperWrapper.closest('.card-wrapper');
  if (!card) return;

  if (card.swiperInstance) return;

  const swiperEl = swiperWrapper.closest('.product-card-swiper');
  if (!swiperEl) return;

  const swiper = initializeSwiper(swiperEl, { draggable: isMobile() });
  const mode = getCurrentMode();
  const correctIndex = mode === 'produit' ? 0 : 1;
  swiper.slideTo(correctIndex, 0);
  card.swiperInstance = swiper;

  setupSwiperEventListeners(card, swiper);
}

function initializeSwiper(swiperEl, options = { draggable: true }) {
  const navNext = swiperEl.querySelector('.swiper-button-next');
  const navPrev = swiperEl.querySelector('.swiper-button-prev');
  const mode = getCurrentMode();
  const startIndex = mode === 'produit' ? 0 : 1; // produit = 0, modele = 1

  return new Swiper(swiperEl, {
    loop: true,
    speed: 500,
    effect: 'creative',
    creativeEffect: {
      prev: {
        translate: ["-20%", 0, -1],
        origin: "center center",
      },
      next: {
        translate: ["100%", 0, 0],
        origin: "center center",
      },
    },
    fadeEffect: {
      crossFade: true
    },
    initialSlide: startIndex,
    touchRatio: options.draggable ? 1 : 0,
    touchAngle: 45,
    navigation: {
      nextEl: navNext,
      prevEl: navPrev,
    },
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    on: {
      init: function () {
        const card = swiperEl.closest('.card');
        const progressBars = card.querySelectorAll('.progress-bar');
        progressBars.forEach(bar => bar.classList.remove('active'));
        progressBars[startIndex]?.classList.add('active');
      },
      slideChange: function () {
        const card = swiperEl.closest('.card');
        const progressBars = card.querySelectorAll('.progress-bar');
        progressBars.forEach(bar => bar.classList.remove('active'));
        progressBars[this.realIndex]?.classList.add('active');
      }
    }
  });
}

function initializeAllProductCardSwipers() {
  const cards = document.querySelectorAll('.card-wrapper');
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const swiperWrapper = entry.target;
        loadRemainingImages(swiperWrapper);
        observer.unobserve(swiperWrapper);
      }
    });
  }, {
    rootMargin: '200px' 
  });

  cards.forEach((card) => {
    if (card.swiperInstance) return;

    const swiperEl = card.querySelector('.product-card-swiper');
    if (swiperEl) {
      const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
      
      if (swiperWrapper) {
        if (swiperWrapper.hasAttribute('data-remaining-images')) {
          imageObserver.observe(swiperWrapper);
        } else {
          initializeSwiperForCard(swiperWrapper);
        }
      }
    }
  });
}
